import React, { memo, useEffect, useState } from 'react';
import { ErrorBoundary } from '@web/utils';
import { BlockSectionProvider } from '../';
import { BlockSectionList } from './BlockSectionList';
export var BlockSection = memo(function (_a) {
    var id = _a.id;
    var _b = useState(false), isColumn = _b[0], setIsColumn = _b[1];
    useEffect(function () { return setIsColumn(['left', 'right', 'main'].includes(id)); }, [id]);
    return (React.createElement(ErrorBoundary, null,
        React.createElement(BlockSectionProvider, { isColumn: isColumn, blockSectionId: id },
            React.createElement(BlockSectionList, { id: id }))));
});
